import { useMemo } from "react";
import { truncateInMiddle } from "utils/truncateInMiddle";

export const useShortAddress = (address: string) => {
  return useMemo(() => truncateInMiddle(address), [address]);
};
